import { withTranslation } from "react-i18next";
import TagSKUVW from './TagSKUVW';

export default withTranslation()(TagSKUVW);